/** Formatting helpers of the super-admin screens (money comes from `eventPrice.ts`). */

const LOCALES: Record<string, string> = { fr: 'fr-FR', en: 'en-GB', es: 'es-ES' }

export const localeOf = (language: string): string => LOCALES[language] ?? 'fr-FR'

/** "26 sept. 2026, 14:30" — event date and time in the viewer's language (Paris time, like the API mails). */
export function formatAdminDateTime(iso: string, language = 'fr'): string {
  return new Intl.DateTimeFormat(localeOf(language), {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone: 'Europe/Paris',
  }).format(new Date(iso))
}

/** "26 sept. 2026". */
export function formatAdminDate(iso: string, language = 'fr'): string {
  return new Intl.DateTimeFormat(localeOf(language), {
    dateStyle: 'medium',
    timeZone: 'Europe/Paris',
  }).format(new Date(iso))
}

/** Thousands separators: 1234 -> "1 234" (fr) / "1,234" (en). */
export function formatCount(value: number, language = 'fr'): string {
  return new Intl.NumberFormat(localeOf(language)).format(value)
}

/** "1–20 of 154": the range shown by a page of results. */
export function pageRange(page: number, limit: number, total: number): { from: number; to: number } {
  if (total === 0) return { from: 0, to: 0 }
  const from = (page - 1) * limit + 1
  return { from, to: Math.min(page * limit, total) }
}

/** The stable `code` of an API error envelope (`Events.OrganizerInvitation.AccountExists`…), if any. */
export function apiErrorCode(error: unknown): string | undefined {
  return (error as { response?: { data?: { code?: string } } })?.response?.data?.code
}

/** A parameter of an API error envelope (`accountId` of `AccountExists`…). */
export function apiErrorParam(error: unknown, name: string): string | undefined {
  const params = (error as { response?: { data?: { params?: Record<string, unknown> } } })?.response?.data?.params
  const value = params?.[name]
  return typeof value === 'string' ? value : undefined
}

/** Looks like an email address (enough to prefill the invitation field). */
export const looksLikeEmail = (value: string): boolean => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())
